define('views/modules/calendar/nutrition/food/edit/food-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    'services/nutrition/nutrients',
    // models & collections
    'models/calendar/nutrition/serving',
    'collections/calendar/nutrition/nutrients',
    // views
    'src/views/form-view',
    'views/modules/calendar/nutrition/food/details/details-form',
    'views/modules/calendar/nutrition/nutrient/form/nutrient-form',
    'views/parts/modal/image-modal',
    // templates
    'text!templates/modules/calendar/nutrition/food/edit/food-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    NutrientService,
    // models & collections
    MServing,
    CNutrients,
    // views
    VForm,
    VFoodDetailsForm,
    VNutrientForm,
    VImageModal, 
    // templates
    TFoodCreateForm
) {

    var VFoodForm = VForm.extend({
        template: TFoodCreateForm,
        tagName: 'form',

        regions: {
            form: ".food-details-form",
            macro: ".food-macro",
            micro: ".food-micro",
            photo: ".food-photo-edit",
        },

        events: {
            "click .edit-button": "onPhotoClick",
        },

        initialize: function(options) {
            options = options || {}; // additional options passed to the constructor.

            var model = this.model,
                serving = this.serving = new MServing(),
                nutrients = this.nutrients = new Backbone.Model(),
                collection = this.collection = new CNutrients(),
                macro = this.macro = new CNutrients(null, { macro: true }),
                micro = this.micro = new CNutrients();

            // namespace views inside an object.
            this.view = {
                form: new VFoodDetailsForm({ model: model, serving: serving }),
                macro: new VNutrientForm({ collection: macro }),
                micro: new VNutrientForm({ collection: micro }),
            };

            this.onNutrientSync();

            this.listenTo(model, { 'model:reset': this.onModelReset });
            this.listenTo(this.nutrients, 'model:reset', this.onNutrientReset);
            this.listenToOnce(NutrientService, 'sync', this.onNutrientSync);
            NutrientService.fetch();

        },

        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();

            var view = this.view,
                zone = this.zone;
            this.assign(view.form, zone.$form)
                .renderNutrients();

            return this;
        },

        renderNutrients: function() {
            var view = this.view,
                zone = this.zone;
            if (zone) {
                this.assign(view.macro, zone.$macro)
                    .assign(view.micro, zone.$micro);
            }
            return this;
        },

        setNutrients: function(nutrients) {
            if (!nutrients) this.collection.setModelAttributes({ value: 0 });
            this.nutrients.reset(nutrients);
        },

        applyNutrientsValues: function() {
            this.collection.setNutrients(this.nutrients.attributes);
            // this.renderList();
        },

        resetForm: function() {

        },

        showPhotoModal: function() {
            var view = this.view.modal;
            if (!view) {
                this.view.modal = view = new VImageModal({
                    title: "settings:brand-upload-modal-title",
                    context: this,
                    callback: this.onPhotoChange,
                    cropper: {
                        aspectRatio: 3
                    }
                });
            }
            view.show();
        },

        setPhotoPreview: function(blob) {
            var photoUrl = URL.createObjectURL(blob),
                $photo = this.zone.$photo;
            $photo.attr('src', photoUrl);
        },

        ////////////
        // events //
        ////////////
        onModelReset: function() {
            this.serving.reset((this.model.get('servings') || [])[0]);
            this.nutrients.reset(this.serving.getNutrients());
            this.resetForm();
        },

        onNutrientSync: function() {
            var view = this.view,
                macro = this.macro,
                micro = this.micro,
                collection = this.collection;
            collection.reset();
            macro.reset(NutrientService.getMacronutrients());
            micro.reset(NutrientService.getMicronutrients());
            collection.add(macro.models);
            collection.add(micro.models);
            this.applyNutrientsValues();
        },

        onNutrientReset: function() {
            this.applyNutrientsValues();
        },

        onSubmit: function() {
            var serving = this.serving.toJSON();
            serving.nutrients = this.collection.getNutrients();
            this.model.setServings([serving]);
        },

        onPhotoClick: function() {
            this.showPhotoModal();
        },
    });

    return VFoodForm;
});

